export default [
  {
    path: "visitas",
    name: "visits",
    redirect: { name: "visits-list" },
    children: [
      {
        path: "",
        name: "visits-list",
        component: () => import("@/modules/visits/views/VisitsList.vue"),
      },
      {
        path: ":id",
        name: "visits-show",
        component: () => import("@/modules/visits/views/VisitShow.vue"),
      },
    ],
  },
];
